<template>
  <div class="animated fadeIn">
    <br />
    <spinner v-if="loading"></spinner>
    <b-card header-tag="header" v-if="!loading && ebook">
      <b-card-body>
        <b-row v-if="!loading">
          <b-col sm="12">
            <b-alert variant="primary" show class="text-center"><h5><b>Passo 1</b>: Escolha a capa para personalizar e usar sua logo</h5></b-alert> 
          </b-col>
          <br />
          <ebook-page-box
            v-for="(page, index) in pages"
            v-bind:thumbnail="page.thumbnail"
            v-bind:fullImage="page.fullImage"
            v-bind:watermarked="page.fullImage"
            v-bind:key="index"
            v-bind:page="page"
            v-bind:selected="page.selected"
            v-bind:simpleVersion="true"
            v-bind:actionText="'Escolher Capa'"
            v-on:page:selected="chooseCover(index)"
            v-on:page:unselected="chooseCover(index)"
            color="bg-secondary"
          >
            <h6></h6>
          </ebook-page-box>
        </b-row>
        <!--
        <div class="center" v-if="nothingAvailable == false && loading == false">
          <div class="overflow-auto">
            <div class="mt-3">
              <b-pagination
                v-if="nothingAvailable == false"
                :total-rows="totalPages * perPage"
                :per-page="perPage"
                v-model="currentPage"
                v-on:input="startList"
                align="center"
                prev-text="Anterior"
                next-text="Próxima"
              ></b-pagination>
            </div>
          </div>
        </div>-->
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import EbookPageBox from "./theme/EbookPageBox";
import service from "./../service";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import Multiselect from "vue-multiselect";
import { constants } from "fs";
import { isMobile } from "mobile-device-detect";
import Spinner from "./Spinner";
import { isIOS } from "mobile-device-detect";

export default {
  name: "ChooseEbookPage",
  props: {
    isMine: false
  },
  data: function() {
    return {
      currentPage: 1,
      perPage: 24,
      totalPages: 1,
      selectedCategories: [],
      taggingSelected: null,
      includeExpress: true,
      includeAdvanced: true,
      loading: true,
      onlyIncludeAdvanced: false,
      modalShow: false,
      noTemplateUsed: false,
      searchId: "",
      isMobileScreen: isMobile,
      isIOS: isIOS,
      nextPageIndex: 1,
      me: undefined,
      pages: [],
      ebook: {},
      selected: []
    };
  },
  computed: {
    templateName() {
      return localStorage.templateName;
    },
    currentRouteName() {
        return this.$route.name;
    }
  },
  created: function() {
    this.modalShow = true;

    service.getEbookCovers(this.$route.params.id).then(result => {
        this.pages = result.pages;
        this.loading = false;
    });

    this.currentPage = 1;
  },
  methods: {
    chooseCover(index) {
      this.pages[index].selected = this.nextPageIndex;

      if (this.currentRouteName.indexOf("Custom") >= 0) {
        this.$router.push({ name: 'CustomEditor', params: {id: this.pages[index].template, customSavingUrl: "/custom-ebook/" + this.$route.params.id + "/save-cover/"}});
      } else {
        this.$router.push({ name: 'Editor', params: {id: this.pages[index].template, customSavingUrl: "/ebook/" + this.$route.params.id + "/save-cover/"}});
      }
    },
    showModal() {
      this.showModal = true;
    },
    hideModal() {
      this.$refs["bv-modal-example"].hide();
    },
    toggleModal() {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.$refs["bv-modal-example"].toggle("#toggle-btn");
    },
    addTag(newTag) {
      this.searchId = "";
      let tag = {
        _id: new Date().getTime(),
        name: newTag,
        userCreatedSearch: true
      }
      //this.categoriesList.push(tag);
      this.selectedCategories.push(tag);
      this.searchTemplates(this.selectedCategories);
    }
  },
  components: { EbookPageBox, VueBootstrapTypeahead, Multiselect, Spinner }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



<style lang="css" scoped>
.background-multiSelect >>> .multiselect__tag {
  background: #20a8d8 !important;
}
.center-text {
  text-align: center !important;
}
.margin-extra {
  margin: 20px !important;
  width: unset !important;
}
</style>
